<template>

    <v-action :name="name">
        <v-input-numeric :model="model" :min="min" :max="max" @input="onInput" />
    </v-action>

</template>

<script>

import Action from './Action';

export default {

    components: {
        'v-action': Action,
    },

    props: {
        type: {
            type: String,
            required: true,
        },
        min: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: 1000,
        },
        perc: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

        model() {
            return parseInt(this.block[this.key].replace(/\D/g, '') || 0);
        },

        name() {
            let name = '';
            if (this.type === 'width') {
                name = 'Width';
            } else if (this.type === 'height') {
                name = 'Height';
            } else if (this.type === 'max-width') {
                name = 'Max Width';
            } else if (this.type === 'max-height') {
                name = 'Max Height';
            } else if (this.type === 'letter-spacing') {
                name = 'Letter Spacing';
            } else if (this.type === 'line-height') {
                name = 'Line Height';
            } else if (this.type === 'font-size') {
                name = 'Font Size';
            } else if (this.type === 'border-top-width') {
                name = 'Height';
            } else if (this.type === 'border-radius') {
                name = 'Radius';
            }
            return this.perc ? `${name} (%)` : name;
        },

        key() {
            let key = '';
            if (this.type === 'width') {
                key = 'width';
            } else if (this.type === 'height') {
                key = 'height';
            } else if (this.type === 'max-width') {
                key = 'max_width';
            } else if (this.type === 'max-height') {
                key = 'max_height';
            } else if (this.type === 'letter-spacing') {
                key = 'letter_spacing';
            } else if (this.type === 'line-height') {
                key = 'line_height';
            } else if (this.type === 'font-size') {
                key = 'font_size';
            } else if (this.type === 'border-top-width') {
                key = 'border_top_width';
            } else if (this.type === 'border-radius') {
                key = 'border_radius';
            }
            return key;
        },

    },

    methods: {

        onInput(val) {
            let block = this.block;
            let value = val + (this.perc ? '%' : 'px');
            block[this.key] = value;
            if (this.key === 'size') {
                block['height'] = value;
            }
            this.$store.commit('builder/setSelectedBlock', block);
        },

    },

}

</script>